import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UnauthorizedService {
  isUnauthorized = signal(false);
  set() {
    this.isUnauthorized.set(true);
  }
  clear() {
    this.isUnauthorized.set(false);
  }
}
